import { createSelector } from "reselect";

const pendingArtisanProductsStateSelector = (state) =>
  state.pendingArtisanProducts;
const selectById = (state, itemId) => itemId;
export const pendingArtisanProductsSelector = createSelector(
  [pendingArtisanProductsStateSelector],
  (products) => products.items
);

export const pendingArtisanProductsAsListSelector = createSelector(
  [pendingArtisanProductsSelector],
  (products) =>
    products.map((product) => {
    
      return {
        name: product.name,
        _id: product._id,
   
      };
    })
);

/* export const pendingArtisanProductsAsListSelector = createSelector(
  [pendingArtisanProductsSelector],
  (products) =>
    products.filter((product) => {
      if (product.artisanProductData.length > 0) {
        return {
          name: product.artisanProductData[0].name,
          _id: product.artisanProductData[0]._id,
          moderationId: product._id,
        };
      }
    })
); */
export const pendingArtisanProductsIsLoadingSelector = createSelector(
  [pendingArtisanProductsStateSelector],
  (products) => products.isLoading
);

export const pendingArtisanProductsCountSelector = createSelector(
  [pendingArtisanProductsStateSelector],
  (products) => products.count
);


export const pendingArtisanProductByIdSelector = createSelector(
  [pendingArtisanProductsSelector, selectById],
  (artisans, _id) => {
    const pendingArtisan = artisans.find((item) => _id === item._id);
    console.log( pendingArtisan, _id)
    if (!pendingArtisan) return null;
    return pendingArtisan;
  }
);